import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/keyboard-numeric/keyboard-numeric.js';
      import {ObcKeyboardNumericType} from '@oicl/openbridge-webcomponents/dist/components/keyboard-numeric/keyboard-numeric.js';
import {ObcNumberInputFieldTextAlign} from '@oicl/openbridge-webcomponents/dist/components/number-input-field/number-input-field.js';

      export interface Props {
     type?: ObcKeyboardNumericType;
     hasTitleBar?: boolean;
     label?: string;
     value?: string;
     hasCalculation?: boolean;
     has2Symbols?: boolean;
     helperText?: string;
     hasLeadingIcon?: boolean;
     unit?: string;
     inputFieldTextAlign?: ObcNumberInputFieldTextAlign;
     validationPattern?: string
   }

      
  
      export type {ObcKeyboardNumericType} from '@oicl/openbridge-webcomponents/dist/components/keyboard-numeric/keyboard-numeric.js';
export type {ObcNumberInputFieldTextAlign} from '@oicl/openbridge-webcomponents/dist/components/number-input-field/number-input-field.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcKeyboardNumeric',
  props: {
    type: {},
    hasTitleBar: { type: Boolean },
    label: {},
    value: {},
    hasCalculation: { type: Boolean },
    has2Symbols: { type: Boolean },
    helperText: {},
    hasLeadingIcon: { type: Boolean },
    unit: {},
    inputFieldTextAlign: {},
    validationPattern: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-keyboard-numeric',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})